import { render, staticRenderFns } from "./ProjectStatistics.vue?vue&type=template&id=170a7960&scoped=true&"
import script from "./ProjectStatistics.vue?vue&type=script&lang=js&"
export * from "./ProjectStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatistics.vue?vue&type=style&index=0&id=170a7960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a7960",
  null
  
)

export default component.exports